import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-reply",
  "use": "icon-reply-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 16 16\" id=\"icon-reply\">\r\n<path d=\"M2.8,16l-0.3-3.2H0V0h16v12.8H7.3L2.8,16z M1,11.8h2.4l0.2,2.4l3.3-2.4H15V1H1V11.8z M3,5h2v2H3V5z M7,5h2v2H7V5z M11,5h2v2\r\n\th-2V5z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./assets/svg/reply.svg
// module id = 307
// module chunks = 0 1